// extracted by mini-css-extract-plugin
export default {"subSectionTitle":"ConfigurationStep_subSectionTitle__bZsSr"};